import { motion } from "framer-motion";
import { ArrowRight, Phone } from "lucide-react";

const HERO_IMG =
  "https://static.prod-images.emergentagent.com/jobs/a2c59b25-30f1-4359-838d-3ea682316c82/images/6b5cb9f2081f3a3da1500733bb4f843d80ae8beeeeefddf663cf70fcc6c9293b.png";

export const Hero = () => {
  return (
    <section id="top" className="relative h-[100vh] min-h-[720px] w-full overflow-hidden" data-testid="hero-section">
      <img
        src={HERO_IMG}
        alt="Premium estate managed by Greenroute"
        className="absolute inset-0 w-full h-full object-cover"
      />
      <div className="absolute inset-0 hero-gradient" />
      <div className="absolute inset-0 grain" />

      <div className="relative z-10 max-w-7xl mx-auto px-6 md:px-12 h-full flex flex-col justify-end pb-24 md:pb-32">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.9, delay: 0.2 }}
        >
          <div className="uppercase text-xs tracking-[0.3em] text-cream/80 mb-8" data-testid="hero-overline">
            Estate Management · South Africa · Est. 2024
          </div>
        </motion.div>

        <motion.h1
          initial={{ opacity: 0, y: 40 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 1, delay: 0.4 }}
          className="font-serif text-cream text-5xl md:text-7xl lg:text-8xl leading-[0.95] tracking-tight max-w-5xl"
          data-testid="hero-title"
        >
          Managed with
          <span className="italic text-gold"> Precision.</span>
          <br />
          Built on Trust.
        </motion.h1>

        <motion.p
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.9, delay: 0.7 }}
          className="text-cream/85 text-base md:text-lg max-w-xl mt-8 leading-relaxed"
          data-testid="hero-subtitle"
        >
          Comprehensive maintenance, repairs and management for residential and
          commercial complexes — preserving asset value, ensuring resident safety,
          and fostering thriving communities across South Africa.
        </motion.p>

        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.9, delay: 0.95 }}
          className="flex flex-col sm:flex-row gap-4 mt-10"
        >
          <a
            href="#contact"
            data-testid="hero-cta-quote"
            className="inline-flex items-center gap-3 bg-cream text-forest px-7 py-4 text-sm tracking-wider hover:bg-gold hover:text-cream transition-colors duration-300"
          >
            Request a Quote
            <ArrowRight size={18} />
          </a>
          <a
            href="tel:+27661833893"
            data-testid="hero-cta-call"
            className="inline-flex items-center gap-3 border border-cream/40 text-cream px-7 py-4 text-sm tracking-wider hover:bg-cream/10 transition-colors duration-300"
          >
            <Phone size={18} />
            +27 66 183 3893
          </a>
        </motion.div>
      </div>

      {/* decorative bottom stats */}
      <motion.div
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ duration: 1, delay: 1.3 }}
        className="absolute bottom-0 left-0 right-0 z-10 border-t border-cream/15 backdrop-blur-sm bg-forest/30"
        data-testid="hero-stats"
      >
        <div className="max-w-7xl mx-auto px-6 md:px-12 grid grid-cols-2 md:grid-cols-4 divide-x divide-cream/15">
          {[
            { v: "24/7", l: "Emergency Response" },
            { v: "4", l: "Provinces Covered" },
            { v: "8+", l: "Service Categories" },
            { v: "100%", l: "Vetted Teams" },
          ].map((s) => (
            <div key={s.l} className="py-6 px-4 text-center md:text-left">
              <div className="font-serif text-3xl text-cream">{s.v}</div>
              <div className="uppercase text-[10px] tracking-[0.25em] text-cream/70 mt-1">
                {s.l}
              </div>
            </div>
          ))}
        </div>
      </motion.div>
    </section>
  );
};

export default Hero;
